import api from './api';

export async function getSunatMappings(supplierId) {
  const response = await api.get('/sunat/mappings', { params: { supplier_id: supplierId } });
  return response.data;
}

export async function saveSunatMappings(supplierId, mappings) {
  const response = await api.post('/sunat/mappings', { supplier_id: supplierId, mappings });
  return response.data;
}

export async function getSunatMappingsAll(params = {}) {
  const response = await api.get('/sunat/mappings/all', { params });
  return response.data;
}

export async function updateSunatMapping(id, data) {
  const response = await api.put(`/sunat/mappings/${id}`, data);
  return response.data;
}

export default { getSunatMappings, saveSunatMappings, getSunatMappingsAll, updateSunatMapping };
